import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  subtitle,
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Logo */}
        <div className="flex justify-center">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center">
              <svg
                className="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>
            </div>
            <div>
              <span className="text-2xl font-bold text-secondary-900">
                Signals
              </span>
              <span className="ml-1 text-xs font-medium text-primary-600 bg-primary-50 px-1.5 py-0.5 rounded">
                Admin
              </span>
            </div>
          </div>
        </div>

        {/* Title and subtitle */}
        {(title || subtitle) && (
          <div className="mt-6 text-center">
            {title && (
              <h2 className="text-3xl font-bold text-secondary-900">{title}</h2>
            )}
            {subtitle && (
              <p className="mt-2 text-sm text-secondary-600">{subtitle}</p>
            )}
          </div>
        )}
      </div>

      {/* Card container */}
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-soft sm:rounded-xl sm:px-10 border border-secondary-100">
          {children}
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 text-center">
        <p className="text-sm text-secondary-500">
          Signals Admin Dashboard - Platform Administration
        </p>
        <p className="mt-1 text-xs text-secondary-400">
          Authorized personnel only
        </p>
      </div>
    </div>
  );
};

export default AuthLayout;
